import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { formatOrdinals } from 'app/i18n/utils';
import SelectDropdown from 'app/components/SelectDropdown';

import style from './style.scss';

interface Props {
  total: number;
  value: number | null;
  onChange: (epicMonsterIndex: number | null) => void;
  disabled?: boolean;
  onlyLabel?: boolean;
}

const LolEpicMonsterIndexInput: FC<Props> = ({ total, value, onChange, disabled, onlyLabel }) => {
  const options = [...Array(total).keys()].map(index => ({
    label: formatOrdinals(index + 1),
    value: index + 1
  }));

  const handleChange = (epicMonsterIndex: '' | number) => {
    if (epicMonsterIndex === '') {
      onChange(null);
    } else {
      onChange(epicMonsterIndex);
    }
  };

  if (onlyLabel) {
    return <>{value ? options[value - 1].label : ''}</>;
  }

  return (
    <SelectDropdown
      value={value ?? ''}
      label="XX"
      width={200}
      portalClassName={style.portal}
      withIcon={false}
      options={options}
      onChange={handleChange}
      disabled={disabled}
      variation="inline"
    />
  );
};

const ControlledLolEpicMonsterIndexInput: FC<Props> = ({ onChange, value, ...props }) => {
  const [epicMonsterIndex, setEpicMonsterIndex] = useState<null | number>(value);

  useEffect(() => {
    setEpicMonsterIndex(value);
  }, [value]);

  const handleChange = (epicMonsterIndex: number | null) => {
    setEpicMonsterIndex(epicMonsterIndex);
    onChange(epicMonsterIndex);
  };

  return <LolEpicMonsterIndexInput onChange={handleChange} value={epicMonsterIndex} {...props} />;
};

export { ControlledLolEpicMonsterIndexInput, LolEpicMonsterIndexInput };
